import { render, staticRenderFns } from "./WapJSY001View.vue?vue&type=template&id=ee4a6bf2&"
import script from "./WapJSY001View.vue?vue&type=script&lang=js&"
export * from "./WapJSY001View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports